import ReactDatepicker from 'react-datepicker';
import { getDateFormats } from './dateUtils';

export default class Datepicker extends React.PureComponent {
  static defaultProps = {
    dateFormat: window.Edocat.Config?.dateFormat || window.Edocat.texts?.dateTimeFormat,
  };

  render() {
    return (
      <ReactDatepicker
        {...this.props}
        autoComplete="off"
        dateFormat={getDateFormats(this.props.dateFormat, this.props.timeFormat)}
        locale={window.Alfresco.constants.JS_LOCALE}
        timeCaption={window.Alfresco.messages.global['label.time']}
      />
    );
  }
}
